export const CHANGE_LANGUAGE = 'INTL/CHANGE_LANGUAGE'
export const UPDATE_INTL = '@@intl/UPDATE'

export const changeLanguage = locale => ({
  type: CHANGE_LANGUAGE,
  locale
})

export const updateIntl = ({ locale, messages }) => ({
  type: UPDATE_INTL,
  payload: { locale, messages }
})
